/**
 * @description: 颜色选择组件
 * @author: zhouyh
 * @time: 2023/8/10 10:04
 */
import React from "react";
import filterModalStyles from "../../filterModal.module.scss";
import { Color } from "@/store/modules/filterConditions";
import classNames from "classnames";
import { useFilterConditionContext } from "@/src/provider";
import { useTranslation } from "@/src/i18n/client";

const ColorContent: React.FC = () => {
    const [colorData, colorSelect] = useFilterConditionContext((state) => [
        state.colorData,
        state.colorSelect,
    ]);
    const { t } = useTranslation("specialSub");

    const colorChange = (obj: Color) => {
        colorSelect(obj);
    };

    return (
        <div
            className={classNames(
                filterModalStyles["filter-content-item"],
                filterModalStyles["filter-content-color"],
            )}
        >
            {colorData.map((val, key) => {
                const style: React.CSSProperties = {};
                if (val.borderColor) {
                    style.border = `0.02rem solid ${val.borderColor}`;
                }
                style.background = val.img
                    ? `url(${val.img}) no-repeat center center`
                    : val.color;
                style.backgroundSize = "cover";

                return (
                    <div
                        key={key}
                        className={filterModalStyles["filter-color"]}
                        onClick={() => {
                            colorChange(val);
                        }}
                    >
                        <div
                            className={classNames(
                                filterModalStyles["color-item"],
                                {
                                    [filterModalStyles["color-item-active"]]:
                                        val.active,
                                },
                            )}
                        >
                            <div
                                className={filterModalStyles["color-item-back"]}
                                style={style}
                            ></div>
                        </div>
                        <div>{t(`${val.title}`)}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default ColorContent;
